module.exports = __webpack_public_path__ + "static/media/mt-ut-img-3-1.013ca0a0.jpg";